<template>
  <div>
    <v-container class="app-breadcrumbs-container">
      <v-breadcrumbs class="app-breadcrumbs" :items="breadcrumbs">
        <v-icon slot="divider">chevron_right</v-icon>
        <template slot="item" slot-scope="props">
          <router-link
            :to="props.item.to"
            :class="[
              props.item.disabled && 'v-breadcrumbs__item--disabled',
              'app-breadcrumbs__item'
            ]"
          >
            {{ props.item.text }}
          </router-link>
        </template>
      </v-breadcrumbs>
    </v-container>
    <div class="main-title">
      <v-container fill-height>
        <v-layout
          align-center
          style="justify-content: space-between;flex-wrap: wrap;"
        >
          <div style="white-space: nowrap">
            {{ orderStatusList[orderDetail.status] }}
          </div>
          <button
            class="button shadow"
            v-if="orderDetail.status === 4"
            @click="reCreateOrder"
            style="margin: 0 auto;"
          >
            {{ $t("order.reOrder") }}
          </button>
        </v-layout>
      </v-container>
    </div>

    <v-container pa-2 mb-5>
      <div class="notice-tips" v-if="orderDetail.status === 6">
        El pedido ha sido cancelado, si tiene alguna pregunta, comuníquese
        con:{{ storeInfo.mobile }}
      </div>
      <v-stepper
        :value="orderDetail.status > 3 ? 4 : orderDetail.status + 1"
        mb-5
        v-if="!breakpoint.mdAndDown && orderDetail.status !== 6"
      >
        <v-stepper-header>
          <v-stepper-step step="1" :complete="orderDetail.status > 0">
            {{ $t("order.step_one") }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2" :complete="orderDetail.status > 1">
            {{ $t("order.step_two") }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="3" :complete="orderDetail.status > 2">
            {{
              orderDetail.takeType == "out"
                ? $t("order.step_three")
                : $t("order.step_three_in")
            }}
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="4" :complete="orderDetail.status > 3">
            {{ $t("order.step_four") }}
          </v-stepper-step>
        </v-stepper-header>
      </v-stepper>

      <v-stepper
        :value="orderDetail.status > 3 ? 4 : orderDetail.status + 1"
        mb-5
        vertical
        v-if="breakpoint.mdAndDown"
      >
        <v-stepper-step step="1" :complete="orderDetail.status > 0">
          {{ $t("order.step_one") }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="2" :complete="orderDetail.status > 1">
          {{ $t("order.step_two") }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="3" :complete="orderDetail.status > 2">
          {{ $t("order.step_three") }}
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step step="4" :complete="orderDetail.status > 3">
          {{ $t("order.step_four") }}
        </v-stepper-step>
      </v-stepper>

      <v-layout class="tip">
        <!-- Thank you. Your order has been received. -->
      </v-layout>
      <v-layout wrap>
        <v-flex>
          <div class="info-title">{{ $t("order.number") }}:</div>
          <div class="info-detail">{{ orderDetail.no }}</div>
        </v-flex>
        <v-flex>
          <div class="split"></div>
        </v-flex>
        <v-flex>
          <div class="info-title">{{ $t("order.time") }}:</div>
          <div class="info-detail">
            {{ moment(orderDetail.createTime).format("YYYY-MM-DD HH:mm") }}
          </div>
        </v-flex>
        <v-flex>
          <div class="split"></div>
        </v-flex>
        <v-flex>
          <div class="info-title">{{ $t("order.total") }}:</div>
          <div class="info-detail">
            €{{ orderDetail.actuallyPaidAmount | fixed(2, true) }}
          </div>
        </v-flex>
        <v-flex>
          <div class="split"></div>
        </v-flex>
        <v-flex>
          <div class="info-title">{{ $t("order.pay_status") }}:</div>
          <div class="info-detail">
            {{ payStatusList[orderDetail.paymentStatus] }}
          </div>
        </v-flex>
      </v-layout>
      <div class="center-title">{{ $t("order.detail") }}</div>
      <v-layout class="order-row" pa-3>
        <v-flex xs5>{{ $t("order.name") }}</v-flex>
        <v-flex>{{ $t("order.total") }}</v-flex>
      </v-layout>
      <v-layout class="order-row" column>
        <div v-for="(item, index) in orderDetail.items" :key="index + item.id">
          <v-layout pa-3>
            <v-flex xs5 class="product-name">
              {{
                (item.commodity &&
                  item.commodity.commodity_name_json &&
                  item.commodity.commodity_name_json[getTranslateIndex]) ||
                  item.upName ||
                  ((item.commodity && item.commodity.name) || "")
              }}
              <span class="product-num">x {{ item.quantity }}</span>
              <div class="description">{{ item.remark }}</div>
              <span
                v-for="(attr_item, index) in item.attributes"
                :key="attr_item.guid"
              >
                <span
                  style="padding-right: 6px; white-space: nowrap;font-size: 12px;color: #e91f1f;"
                  >{{ attr_item.name }}
                  <span v-if="attr_item.price && Number(attr_item.price)"
                    >€ {{ attr_item.price }}</span
                  >
                </span>
              </span>
            </v-flex>
            <v-flex class="product-num">
              €{{ (item.price * item.quantity) | fixed(2, true) }}
            </v-flex>
          </v-layout>
          <v-layout
            v-for="(garnishItem, garnishIndex) in item.garnish"
            :key="garnishIndex + garnishItem.commodity_name"
          >
            <v-flex xs5 class="garnish-name">
              {{ garnishItem.commodity_name }}
            </v-flex>
            <v-flex class="garnish-price">
              €{{ garnishItem.commodity_price }}
            </v-flex>
          </v-layout>
        </div>
      </v-layout>
      <v-layout class="order-row-info" pa-3>
        <v-flex xs5>{{ $t("order.pay_status") }}:</v-flex>
        <v-flex class="info-right"
          >{{ payStatusList[orderDetail.paymentStatus] }}
        </v-flex>
      </v-layout>
      <v-layout class="order-row-info" pa-3>
        <v-flex xs5>{{ $t("order.pay_type") }}:</v-flex>
        <v-flex class="info-right">
          {{ orderDetail.paymentMethodName }}
        </v-flex>
      </v-layout>
      <v-layout class="order-row-info" pa-3>
        <v-flex xs5>{{ $t("order.discount") }}:</v-flex>
        <v-flex class="info-right"> €-{{ orderDetail.discountAmount }}</v-flex>
      </v-layout>
      <v-layout class="order-row-info" pa-3>
        <v-flex xs5>{{$t("unClass.add393")}}:</v-flex>
        <v-flex class="info-right"
          >€{{ orderDetail.deliveryFee | fixed(2, true) }}
        </v-flex>
      </v-layout>
      <v-layout class="order-row-info" pa-3>
        <v-flex xs5>{{ $t("order.total") }}:</v-flex>
        <v-flex class="info-right"
          >€{{ orderDetail.actuallyPaidAmount | fixed(2, true) }}
        </v-flex>
      </v-layout>
      <v-layout class="order-row-info" pa-3>
        <v-flex xs5>{{ $t("order.address") }}:</v-flex>
        <v-flex class="product-num">
          {{ orderDetail.deliveryInfo && orderDetail.deliveryInfo.address1 }}
        </v-flex>
      </v-layout>
      <v-layout class="order-row-info" pa-3>
        <v-flex xs5>{{ $t("order.remarks") }}:</v-flex>
        <v-flex class="product-num">
          {{ orderDetail.remarks }}
        </v-flex>
      </v-layout>
      <v-layout class="order-row-info" pa-3>
        <v-flex xs5>{{ $t("newAdd.add1") }}:</v-flex>
        <v-flex class="product-num">
          {{ orderDetail.deliveryTime || $t("unClass.add394") }}
        </v-flex>
      </v-layout>

      <div class="phone-container">
        {{ $t("order.phone") }}
        ：{{ storeInfo.mobile }}
      </div>

      <!-- <v-layout column v-if="orderDetail.status !== 6">
              <v-flex>
                <button class="button shadow" @click="submit">
                  {{ $t("order.cancel_btn") }}
                </button>
              </v-flex>
            </v-layout> -->

      <form
        name="from"
        :action="redsysParams.form_action"
        method="POST"
        id="myForm"
      >
        <input
          type="hidden"
          name="Ds_SignatureVersion"
          :value="redsysParams.Ds_SignatureVersion"
        />
        <input
          type="hidden"
          name="Ds_MerchantParameters"
          :value="redsysParams.Ds_MerchantParameters"
        />
        <input
          type="hidden"
          name="Ds_Signature"
          :value="redsysParams.Ds_Signature"
        />
      </form>

      <!-- <button
              class="button shadow"
              v-if="
                orderDetail.guid &&
                  orderDetail.paymentStatus == 0 &&
                  orderDetail.paymentMethod == 'VisaOnline' &&
                  isOpenVisaOnline
              "
              @click="redsystransaction"
            >
              {{ $t("order.pay") }}
            </button> -->
    </v-container>
    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("order.tip_title") }}
          </span>
        </v-card-title>
        <v-card-text>
          <small>{{ $t("order.tip_content") }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="dialog = false">
            {{ $t("order.cancel") }}
          </v-btn>
          <v-btn color="blue darken-1" flat @click="confrimCancel">
            {{ $t("order.confrim") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog top v-model="isOpenCancelOrderSuccess" vertical max-width="500px">
      <v-card color="primary">
        <v-card-title>
          <span>{{ $t("order.cancel_order_success") }}</span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="isOpenCancelOrderSuccess = false">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title>
      </v-card>
    </v-dialog>

    <v-dialog top v-model="isOpenCreateOrderSuccess" vertical max-width="500px">
      <v-card color="primary">
        <v-card-title>
          <span> {{ $t("order.create_order_success") }}</span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="isOpenCreateOrderSuccess = false">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
          </v-menu>
        </v-card-title>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import order from "@/api/order";
import moment from "moment";
import { fixed } from "../../utils";
import { mapGetters, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      orderDetail: {
        deliveryInfo: {}
      },
      moment: moment,
      dialog: false,
      isOpenCancelOrderSuccess: false,
      isOpenCreateOrderSuccess: false,

      redsysParams: {},
      timer: null
    };
  },

  mounted() {
    this.isOpenCreateOrderSuccess =
      this.$route.query.show === "createOrderSuccess";
    // 监听message事件，方法是后台定义和提供的
    this.sockets.subscribe(
      `message_for_customer_${this.userInfo.guid}_${this.$route.params.guid}`,
      data => {
        if (data) {
          console.log("订单详情 socket返回的数据");
          console.log(data);

          this.orderDetail.status = JSON.parse(data).orderStatus;
        }
      }
    );
  },

  sockets: {
    // 通信的name
    //这里是监听connect事件
    connect: function() {
      this.id = this.$socket.id;
      console.log("socket connected");
    }
  },

  watch: {
    isOpenCreateOrderSuccess(value) {
      if (value) {
        return;
      }

      const query = {
        ...this.$router.query,
        show: undefined
      };

      this.$router.replace({ name: "order/detail", query });
    }
  },

  destroyed() {
    this.sockets.unsubscribe(
      `message_for_customer_${this.userInfo.guid}_${this.$route.params.guid}`
    );
    this.timer && clearInterval(this.timer);
  },

  created() {
    this.loadOrderDetail();
    this.timer = setInterval(() => {
      this.loadOrderDetail();
    }, 1000);
  },
  computed: {
    ...mapGetters(["payStatusList", "orderStatusList", "getTranslateIndex"]),
    ...mapState(["payAction", "userInfo", "storeInfo"]),
    breadcrumbs() {
      return [
        {
          to: { name: "home" },
          disabled: false,
          text: this.$t("breadcrumbs.home")
        },
        {
          to: { name: "checkout" },
          disabled: false,
          text: this.$t("breadcrumbs.checkout_detail")
        }
      ];
    },
    breakpoint() {
      return this.$vuetify.breakpoint;
    },
    // 返回true表示店铺开启线上支付
    isOpenVisaOnline() {
      let supportedPaymentMethod = this.storeInfo.supportedPaymentMethod.split(
        ","
      );
      let index = supportedPaymentMethod.indexOf("VisaOnline");
      return index != -1;
    }
  },
  methods: {
    ...mapMutations(["resetCart"]),
    async redsystransaction() {
      let payload = {
        orderGuid: this.orderDetail.guid,
        customerLanguage: 1,
        OKUrl: window.location.origin + "/#/order/list",
        UrlKO: window.location.origin + "/#/order/list"
      };
      try {
        const {
          data: { isError, msg, data }
        } = await order.redsystransaction(payload);

        if (isError) {
          this.tip = msg;
          this.errorDialog = true;
          return;
        }

        this.redsysParams = data;

        setTimeout(() => {
          document.getElementById("myForm").submit();
        }, 1000);
      } catch (e) {
        const {
          response: {
            data: { msg }
          }
        } = e;

        this.errorDialog = true;
        this.tip = msg;
      }
    },

    async loadOrderDetail() {
      try {
        const res = await order.loadOrderDetail({
          guid: this.$route.params.guid
        });
        if (!res.data.isError) {
          this.orderDetail = res.data.data;
        }
      } catch (e) {
        console.log(e.response);
      }
    },
    async confrimCancel() {
      this.dialog = false;
      try {
        const res = await order.cancelOrder({ guid: this.$route.params.guid });
        if (!res.data.isError) {
          this.isOpenCancelOrderSuccess = true;
          this.loadOrderDetail();
        }
      } catch (e) {
        console.log(e.response);
      }
    },
    submit() {
      this.dialog = true;
    },
    reCreateOrder() {
      console.log("create order");
      console.log(this.orderDetail);
      let goodsItem = (this.orderDetail && this.orderDetail.items) || [];
      let cartsData = goodsItem.map(item => {
        return {
          guid: item.commodityGuid,
          num: item.quantity,
          index: null,
          description: item.description,
          remark: item.remark,
          attributes: (item.attributes || []).map(it => it.guid) || [],
          garnish: (item.garnish || []).map(it => it.commodity_guid) || [],
          garnish_items: item.garnish || [],
          total_price: item.total
        };
      });
      this.resetCart(cartsData);

      this.$router.push({ name: "checkout" });
    }
  },
  filters: {
    fixed
  }
};
</script>
<style scoped lang="sass" src="./order-detail.sass"></style>
